const renderUrl = {
  LOCAL: "http://localhost:8081",
  DEV: "https://ebdevnodebackend.evervent.in",
};

export const environment = "DEV";
const finalUrl: any = renderUrl[environment];
const BASE_URL: any = `${finalUrl}/api/`;

export const URL_CONSTANTS = {
  generate_tokken: `${BASE_URL}auth/genrateToken`,
  //On Board
  login_via_username_password: `${BASE_URL}auth/login`,
  forgot_password: `${BASE_URL}forgot-password`,
  //Contacts
  get_contact_list: `${BASE_URL}contact`,
  add_new_contact: `${BASE_URL}contact/add`,
  detail_contact: `${BASE_URL}contact/view/CI880185`,
  edit_contact: `${BASE_URL}contact/edit/CI880185`,
  delete_contact: `${BASE_URL}contact/delete/CI880185`,
};
